module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorText":"Error: invalid authorization url"}}')
  delete Component.options._Ctor
}
